import ProductInterfacesService from '@/services/productInterfaces';

export default {
	namespaced: true,
	state: {
	},

	getters: {    
    async getProductInterfaces(){
      try{
        const response = await ProductInterfacesService.getProductInterfaces();
        if(response.data && response.data.attributes){
          return response.data.attributes
        }
        return [];
      }catch(e){
        console.log(e)
      }
    },		
	},

	actions: {
		async createProductInterface({ commit, state, getters, dispatch }, payload) {
			let response;
			try {
				response = await ProductInterfacesService.createProductInterface({
					...payload
				});
			} catch (e) {
				console.log(e)
			}
			return response;
		},
		async updateProductInterface({ commit, state, getters, dispatch }, payload) {
			let response
			try {
				response = await ProductInterfacesService.updateProductInterface(payload.id, {
					...payload
				})
			} catch (e) {
				console.log(e);
			}
			return response;
		},
		async deleteProductInterface({ commit, state, getters, dispatch }, id) {
			let response;
			try {
				response = await ProductInterfacesService.deleteProductInterface(id);
			} catch (e) {
				console.log(e);
			}
			return response
		}
	},

	mutations: {
		// SET_VALUE_FROM_API(state, payload) {
		// 	state.valueFromApi = payload;
		// }
	}
};
